/**
 * Chaves de liberação (ADR 24/09/2026, STO-1589) — leitura pela tela.
 *
 * Contrato com o motor: `GET /api/v1/release-keys` ->
 * `{ environment, keys: { <chave>: boolean } }`. Valor igual para todas as
 * empresas (a chave é global por ambiente). Rede só via `api.ts`.
 *
 * Falha fechada: qualquer erro, corpo estranho ou valor que não seja o
 * booleano `true` lê DESLIGADO. A tela nunca mostra novidade por engano.
 */
import { api } from '@/lib/api'

/** Chave do comando de voz no chat (registro do motor: `release-keys-registry`). */
export const CHAVE_COMANDO_DE_VOZ = 'comando_de_voz'

export interface ReleaseKeysResponse {
  environment: string
  keys: Record<string, boolean>
}

/** Pausa antes da segunda (e última) leitura. */
export const ESPERA_ANTES_DA_NOVA_TENTATIVA_MS = 1000

/** Normaliza o corpo do motor: só `true` literal vale ligado. */
export function parseReleaseKeys(body: unknown): Record<string, boolean> {
  const keys = (body as { keys?: unknown } | null)?.keys
  if (typeof keys !== 'object' || keys === null || Array.isArray(keys)) return {}
  const out: Record<string, boolean> = {}
  for (const [name, value] of Object.entries(keys)) out[name] = value === true
  return out
}

/**
 * Lê as chaves. Nunca lança: falha de rede/HTTP devolve `{}` (tudo desligado).
 * Uma única nova tentativa cobre o soluço de rede logo após o login (sem ela o
 * microfone ficaria sumido a sessão inteira por uma leitura perdida).
 */
export async function fetchReleaseKeys(): Promise<Record<string, boolean>> {
  for (let tentativa = 0; tentativa < 2; tentativa++) {
    // Espera curta antes da nova tentativa: um soluço de rede não some em 0 ms.
    if (tentativa > 0) await new Promise((r) => setTimeout(r, ESPERA_ANTES_DA_NOVA_TENTATIVA_MS))
    try {
      return parseReleaseKeys(await api.get<ReleaseKeysResponse>('/api/v1/release-keys'))
    } catch {
      // segue para a nova tentativa; depois dela, falha fechada
    }
  }
  return {}
}
